/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Connecting_To_Checkout_RedirInputs */

const en_connecting_to_checkout_redir = /** @type {(inputs: Connecting_To_Checkout_RedirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connecting to checkout, redirecting shortly...`)
};

const es_connecting_to_checkout_redir = /** @type {(inputs: Connecting_To_Checkout_RedirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conectando al pago — redirigiendo en breve...`)
};

const fr_connecting_to_checkout_redir = /** @type {(inputs: Connecting_To_Checkout_RedirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connexion au paiement — redirection en cours...`)
};

const de_connecting_to_checkout_redir = /** @type {(inputs: Connecting_To_Checkout_RedirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verbindung zur Kasse — du wirst in Kürze weitergeleitet...`)
};

const ja_connecting_to_checkout_redir = /** @type {(inputs: Connecting_To_Checkout_RedirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`チェックアウトに接続しています — まもなくリダイレクトされます...`)
};

const zh_connecting_to_checkout_redir = /** @type {(inputs: Connecting_To_Checkout_RedirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在连接到结账页面 — 即将重定向...`)
};

const ar_connecting_to_checkout_redir = /** @type {(inputs: Connecting_To_Checkout_RedirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جاري الاتصال بصفحة الدفع — التوجيه بعد قليل...`)
};

const id_connecting_to_checkout_redir = /** @type {(inputs: Connecting_To_Checkout_RedirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menghubungkan ke checkout — mengalihkan sebentar lagi...`)
};

const it_connecting_to_checkout_redir = /** @type {(inputs: Connecting_To_Checkout_RedirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connessione al checkout in corso — reindirizzamento a breve...`)
};

const ru_connecting_to_checkout_redir = /** @type {(inputs: Connecting_To_Checkout_RedirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подключение к оформлению заказа — сейчас вы будете перенаправлены...`)
};

const pt_connecting_to_checkout_redir = /** @type {(inputs: Connecting_To_Checkout_RedirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conectando ao checkout — redirecionando em breve...`)
};

const ko_connecting_to_checkout_redir = /** @type {(inputs: Connecting_To_Checkout_RedirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`결제 페이지로 연결 중 — 잠시 후 리디렉션됩니다...`)
};

/**
* | output |
* | --- |
* | "Connecting to checkout, redirecting shortly..." |
*
* @param {Connecting_To_Checkout_RedirInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const connecting_to_checkout_redir = /** @type {((inputs?: Connecting_To_Checkout_RedirInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Connecting_To_Checkout_RedirInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_connecting_to_checkout_redir(inputs)
	if (locale === "es") return es_connecting_to_checkout_redir(inputs)
	if (locale === "fr") return fr_connecting_to_checkout_redir(inputs)
	if (locale === "de") return de_connecting_to_checkout_redir(inputs)
	if (locale === "ja") return ja_connecting_to_checkout_redir(inputs)
	if (locale === "zh") return zh_connecting_to_checkout_redir(inputs)
	if (locale === "ar") return ar_connecting_to_checkout_redir(inputs)
	if (locale === "id") return id_connecting_to_checkout_redir(inputs)
	if (locale === "it") return it_connecting_to_checkout_redir(inputs)
	if (locale === "ru") return ru_connecting_to_checkout_redir(inputs)
	if (locale === "pt") return pt_connecting_to_checkout_redir(inputs)
	return ko_connecting_to_checkout_redir(inputs)
});